import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
import { useGetMetricAggregationQuery, MetricCalculationType, useUpdateMetricAggregationMutation, useAddMetricAggregationMutation, TypeAggregationGroup } from '~/types/types';
import { renderMarkdown } from '~/functions/markdown';
export default /*#__PURE__*/_defineComponent({
  __name: 'MetricAggregationContent',
  props: {
    value: null,
    metricId: null
  },
  emits: ["close", "input"],
  setup: function setup(__props, _ref) {
    var _props$value, _aggregation$value, _aggregation$value2;
    var emit = _ref.emit;
    var props = __props;
    var defaultAggregation = {
      calculationType: MetricCalculationType.Sum,
      comment: null,
      groupId: null,
      groupType: undefined,
      deprecatedMetricAggregationValues: [],
      funds: [],
      indicator: '',
      metricAggregationValues: [],
      metricId: undefined,
      portfolioId: undefined,
      id: undefined
    };
    var aggregation = ref(_objectSpread({}, (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : defaultAggregation));
    var selectedFundIds = ref(((_aggregation$value = aggregation.value) === null || _aggregation$value === void 0 ? void 0 : _aggregation$value.groupType) === TypeAggregationGroup.Fund ? [(_aggregation$value2 = aggregation.value) === null || _aggregation$value2 === void 0 ? void 0 : _aggregation$value2.groupId] : []);

    // const assignToAll = ref(
    //   props.value?.groupType === TypeAggregationGroup.PortfolioVentureLink,
    // )

    var _useGetMetricAggregat = useGetMetricAggregationQuery({
        id: computed(function () {
          var _props$value2;
          return (_props$value2 = props.value) === null || _props$value2 === void 0 ? void 0 : _props$value2.id;
        })
      }, computed(function () {
        var _props$value3;
        return {
          enabled: !!((_props$value3 = props.value) !== null && _props$value3 !== void 0 && _props$value3.id)
        };
      })),
      onResult = _useGetMetricAggregat.onResult,
      loading = _useGetMetricAggregat.loading;
    onResult(function (_ref2) {
      var data = _ref2.data;
      if (data !== null && data !== void 0 && data.getMetricAggregation) {
        aggregation.value = _objectSpread({}, data.getMetricAggregation);
        if (aggregation.value.groupType === TypeAggregationGroup.Fund) {
          var _aggregation$value3;
          selectedFundIds.value = [(_aggregation$value3 = aggregation.value) === null || _aggregation$value3 === void 0 ? void 0 : _aggregation$value3.groupId];
        }
      }
    });
    watch(selectedFundIds, function () {
      if (selectedFundIds.value.length > 0) {
        aggregation.value.groupType = TypeAggregationGroup.Fund;
        aggregation.value.groupId = selectedFundIds.value[0];
        // assignToAll.value = false
      }
    });

    // watch(assignToAll, () => {
    //   if (assignToAll.value) {
    //     aggregation.value.groupType = TypeAggregationGroup.PortfolioVentureLink
    //     aggregation.value.groupId = 0
    //     selectedFundIds.value = [] // clear
    //   }
    // })

    var _useAddMetricAggregat = useAddMetricAggregationMutation(),
      addMetricAggregation = _useAddMetricAggregat.mutate;
    var _useUpdateMetricAggre = useUpdateMetricAggregationMutation(),
      updateMetricAggregation = _useUpdateMetricAggre.mutate;
    var isEdit = computed(function () {
      var _props$value4;
      return !!((_props$value4 = props.value) !== null && _props$value4 !== void 0 && _props$value4.id);
    });
    var form = ref(null);
    var disabled = computed(function () {
      if (loading.value) return true;
      if (isEdit.value && aggregation.value.groupType === TypeAggregationGroup.Fund && !aggregation.value.groupId) {
        return true;
      }
      if (selectedFundIds.value.length === 0) {
        return true;
      }
      // if (!assignToAll.value && selectedFundIds.value.length === 0) {
      //   return true
      // }
      return false;
    });
    function submit() {
      var _form$value, _form$value$validate;
      // If we have a form ref and it supports validate, validate before proceeding
      if ((_form$value = form.value) !== null && _form$value !== void 0 && (_form$value$validate = _form$value.validate) !== null && _form$value$validate !== void 0 && _form$value$validate.call(_form$value)) {
        var obj = aggregation.value;
        if (isEdit.value) {
          updateMetricAggregation({
            input: {
              id: obj.id,
              calculationType: obj.calculationType,
              groupId: obj.groupId,
              comment: obj.comment,
              groupType: obj.groupType
            }
          }).then(function () {
            window.$nuxt.$emit('userMsg');
            emit('close');
          });
        } else {
          addMetricAggregation({
            input: {
              metricId: props.metricId,
              calculationType: obj.calculationType,
              groupId: obj.groupId,
              comment: obj.comment,
              groupType: obj.groupType
            }
          }).then(function (data) {
            emit('input', data);
            window.$nuxt.$emit('userMsg');
            emit('close');
          });
        }
      } else {
        window.$nuxt.$emit('userError', {
          message: 'Please check your input',
          color: 'red'
        });
      }
    }
    return {
      __sfc: true,
      emit: emit,
      props: props,
      defaultAggregation: defaultAggregation,
      aggregation: aggregation,
      selectedFundIds: selectedFundIds,
      onResult: onResult,
      loading: loading,
      addMetricAggregation: addMetricAggregation,
      updateMetricAggregation: updateMetricAggregation,
      isEdit: isEdit,
      form: form,
      disabled: disabled,
      submit: submit,
      renderMarkdown: renderMarkdown
    };
  }
});